module.exports = __webpack_public_path__ + "static/media/xl.eac092d3.webp";